<template>
  <p
    :class="['alert', alert.success ? 'alert-success' : 'alert-danger']"
    role="alert"
    v-if="alert.message"
  >
    <span class="close" aria-label="close" @click="closeAlert" v-if="showClose"
      >&times;</span
    >
    <span v-html="alert.message"></span>
  </p>
</template>
<script>
export default {
  name: "volcan-alert",
  props: ["alert"],
  computed: {
    showClose() {
      return this.alert.showClose === undefined ? true : this.alert.showClose;
    },
  },
  methods: {
    closeAlert() {
      this.alert.message = "";
    },
  },
};
</script>
<style scoped>
.alert {
  margin: 20px;
}

.close {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/alert.vue